const regex = {
    halfWidthKana: /^[ｦ-ﾟ]+$/,
    fullWidthKana: /[\u30A0-\u30FF]/,
    num: /^[0-9]+$/,
};

export const isIncludedFullWidthKana = (value) => {
    return regex.fullWidthKana.test(value);
};

/**
 * 報酬設定画面におけるバリデーション
 * @param {string} value
 * @returns {string | null} エラーがあればエラーメッセージを返す
 */
const VALIDATE_REWARD_SETTING = {
    GENDER: (value) => {
        if (value === "title") return "性別を選択してください";
        return null;
    },
    ACCOUNT_PERSON_NAME: (value) => {
        if (!regex.halfWidthKana.test(value)) return "口座名義人は半角カナで入力してください。";
        return null;
    },
    ACCOUNT_NUM: (value) => {
        if (!regex.num.test(value)) return "口座番号は半角数字で入力してください";
        if (value.length !== 7) return "口座番号は7文字で入力してください";
        return null;
    },
};

export default VALIDATE_REWARD_SETTING;